import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.onScroll = this.onScroll.bind(this)
    window.addEventListener("scroll", this.onScroll, { passive: true })
    this.onScroll()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
  }

  onScroll() {
    if (!this.hasButtonTarget) return
    if (window.scrollY > 400) {
      this.buttonTarget.classList.remove("opacity-0", "pointer-events-none", "translate-y-4")
      this.buttonTarget.classList.add("opacity-100", "translate-y-0")
    } else {
      this.buttonTarget.classList.add("opacity-0", "pointer-events-none", "translate-y-4")
      this.buttonTarget.classList.remove("opacity-100", "translate-y-0")
    }
  }

  scrollTop(e) {
    e.preventDefault()
    window.scrollTo({ top: 0, behavior: "smooth" })
  }
}
